/**
 * App spacing measurement convention
 * Use the getSpacing function below to compute padding and margin
 */
const SPACING_UNIT = 5;
const MEASUREMENT_UNIT = 'px';

const filterPalette = {
  violentViolet:
    'invert(8%) sepia(73%) saturate(3221%) hue-rotate(241deg) brightness(96%) contrast(111%)',
  goldTips:
    'invert(72%) sepia(33%) saturate(5079%) hue-rotate(12deg) brightness(106%) contrast(84%)',
  white: 'brightness(0) invert(1)',
};

export const colorFilterUsage = {
  tslLogoInverted: filterPalette.violentViolet,
  tslLogo: filterPalette.white,
};

export const fontSize = {
  giant: '3.4rem', // 55px
  XXXLarge: '3rem', // 48px
  XXLargePlus2: '2.5rem', //40px
  XXLargePlus1: '2rem', //32px
  XXLarge: '1.75rem', // 28px
  XLarge: '1.5rem', // 24px
  large: '1.35rem', // 21.6px
  mediumLarge: '1.2rem', // 19.2px
  medium: '1.125rem', // 18px
  mediumSmall: '1.1rem', // 17px
  small: '1rem', // 16px
  extraSmall: '0.875rem', //12px
  extraExtraSmall: '0.775rem', //12px
  inherit: 'inherit',
};

export const fontWeight = {
  ultraBold: 800,
  bolder: 600,
  bold: 500,
  light: 300,
};

export const lineHeight = {
  giant: '4.7rem', // 75px
  XXLarge: '3.5rem', // 56px
  XLarge: '2.2rem', // 35px
  large: '2rem', // 32px
  medium: '1.5rem', // 24px
  small: '1.2rem', // 19px
};

export const letterSpacing = {
  small: '0',
  normal: '0.05em',
  double: '0.1em',
};

export const borderRadius = {
  rounded: '100px',
  XXXLarge: '30px',
  XXLarge: '20px',
  XLarge: '15px',
  large: '10px',
  medium: '5px',
};

export const mediaQueriesBreakpoints = {
  smallScreen: 'max-width: 600px',
  mediumScreen: 'max-width: 1024px',
  portrait: 'orientation: portrait',
  landscape: 'orientation: landscape',
};

export const getSpacing = (multiplier: number): string =>
  `${multiplier * SPACING_UNIT}${MEASUREMENT_UNIT}`;
